import { useSelector } from "react-redux";
import { makeSelectCurrentDialogNotification } from "../redux/selectors";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const useDialogNotificationState = (): any => {
  const currentDialogNotification = useSelector(
    makeSelectCurrentDialogNotification(),
  );

  const getCurrentParams = () => currentDialogNotification;

  return {
    getCurrentParams,
  };
};

export default useDialogNotificationState;
